import { useTranslation } from 'react-i18next';

const ConnectedBadge = () => {
  const { t } = useTranslation('common', { keyPrefix: 'manage.account_profile.social_connections' });

  return (
    <div className="rounded px-2 py-1 bg-emerald-100 text-emerald-900 border border-emerald-200 text-xs font-medium">
      {t('connected_label')}
    </div>
  );
};

export default ConnectedBadge;
